<template>
  <div class="autoComplete">
    <i-input v-model="currentValue"
             :size="size"
             :placeholder="placeholder"
             @on-change="onCurrentChange"
             @on-focus="onInputFocus"
             @on-blur="onInputBlur" :disabled="disabled"></i-input>
    <transition name="transition-drop">
      <div class="ivu-select-dropdown"
           v-show="showDropDown && filterData.length>0"
           style="min-width: 200px; position: absolute; will-change: top, left; transform-origin: center top; top: 32px; left: 0px;"
           x-placement="bottom-start">
        <ul class="ivu-select-dropdown-list">
          <li class="ivu-select-item"
              v-for="(item,index) in filterData"
              :key="index"
              @click="onSelect(item)">{{labelProp ? getObjectValue(item,labelProp) : item}}</li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'auto-complete',
  props: {
    value: {
      type: [String, Number]
    },
    data: {
      type: Array,
      default: () => []
    },
    labelProp: {
      type: [String, Array],
      default: ''
    },
    size: {
      validator (value) {
        return oneOf(value, ['small', 'large', 'default']);
      }
    },
    filterMethod: {
      type: [Function, Boolean],
      default: false
    },
    placeholder: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: '',
      currentData: '',
      showDropDown: false,
      disableEmitChange: false,
      inputTimer: null
    };
  },
  computed: {
    filterData () {
      if (this.filterMethod) {
        return this.data.filter(item =>
          this.filterMethod(
            this.currentValue,
            this.labelProp ? this.getObjectValue(item, this.labelProp) : item
          )
        );
      } else {
        return this.data;
      }
    }
  },
  methods: {
    getObjectValue (data, keys) {
      let result = keys.length > 0 ? data[keys[0]] : data;
      let newKeys = Object.assign([], keys);
      if (newKeys.length > 0) {
        newKeys.splice(0, 1);
        return this.getObjectValue(result, newKeys);
      } else {
        return result;
      }
    },
    onInputFocus () {
      //   if (this.filterData.length > 0) {
      this.showDropDown = true;
      //   }
      this.$emit('on-focus');
    },
    onInputBlur () {
      if (this.showDropDown) {
        this.showDropDown = false;
      }
      this.$emit('on-blur');
    },
    onSelect (item) {
      if (this.labelProp) {
        // 对象
        this.currentValue = this.getObjectValue(item, this.labelProp);
        this.currentData = JSON.parse(JSON.stringify(item));
      } else {
        this.currentValue = item;
        this.currentData = item;
      }
      this.showDropDown = false;

      this.$nextTick(() => {
        this.$emit('input', this.currentValue);
        this.$emit('on-change', this.currentValue, this.currentData);
        this.$emit('on-select', this.currentValue, this.currentData);
      });
    },
    onCurrentChange () {
      if (this.inputTimer) {
        clearTimeout(this.inputTimer);
        this.inputTimer = null;
        // 重置计时器
      }
      this.inputTimer = setTimeout(() => {
        this.$emit('input', this.currentValue);
        this.$emit('on-change', this.currentValue, this.currentData);
        this.$emit('on-search', this.currentValue, this.currentData);
      }, 500);
    }
  },
  watch: {
    value (val) {
      // if (this.currentValue !== val) {
      //   this.disableEmitChange = true;
      // }
      this.currentValue = val;
      console.log(this.currentValue, val);
    }
    // currentValue (val) {
    //   this.$emit('input', val);
    //   // if (this.disableEmitChange) {
    //   //   this.disableEmitChange = false;
    //   //   return;
    //   // }

    // }
  }
};
</script>

<style lang="scss" scoped>
.autoComplete {
  width: 100%;
  ul {
    li {
      height: auto !important;
      line-height: normal;
      &:nth-of-type(2) {
        margin-left: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/autoComplete/main.vue